<script setup>
/*
    Sign (post) widget

    Components:
        primary: <vu-sign>

    Widget Properties:
        value: []

    Component Args

    CSS Properties:
 */
import {reactive} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
})

const primary = ref(null)

function update() {
    Object.assign(page, getWidgetProps(props.widget, {primary}))
}
</script>

<template>
    <vu-sign
        ref="primary"
        v-bind="page.args"
        :name="`sign-widget-${widget.header}`"
        :title="widget.header"
        color="accent"
        class="sign-widget">
        <p>{{ page.data.primary }}</p>
    </vu-sign>
</template>

<style lang="scss">
.sign-widget {
    height: 100%;
    font-size: 1rem;
    border-radius: 0 !important;
    .sign-title {
        font-size: 1rem !important;
    }
}
</style>
